<template>
    <v-layout fill-height>
        <v-flex class="quick-link-items">
            <v-flex
                v-for="(category, index) in categoryList"
                :key="category.key"
                :class="['quick-link-items__row', isActive(category)]"
                @click="setSelectedCategory(category)"
                :id="category.key"
                :data-qe-id="'quickLink_SideIcon' + index"
            >
                {{ category.displayName }} ({{ getCategoryLength(category) }})
            </v-flex>
        </v-flex>
    </v-layout>
</template>

<script>
import { myToolsConstants } from '../mytools.constant.js';

export default {
    name: 'QuickSideLayout',
    data: () => ({
        myToolsConstants,
    }),
    props: {
        categoryList: {
            type: Array,
            required: true,
        },
        selectedCategory: {
            type: Object,
            required: true,
        },
        selectedCategoryHandler: {
            type: Function,
            required: true,
        },
        myQuickLinksLength: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    methods: {
        setSelectedCategory(category) {
            this.selectedCategoryHandler(category);
        },
        isActive(category) {
            return this.selectedCategory && this.selectedCategory.key === category.key ? 'selectedLink' : '';
        },
        getCategoryLength(category) {
            return category && category.key === myToolsConstants.QUICK_LINKS.QuickLinks
                ? `${this.myQuickLinksLength} of ${myToolsConstants.QUICK_LINKS.TWENTY_FOUR}`
                : category.links.length;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../common/styles/_colors.scss';
@import '../../../common/styles/_responsive.scss';

.quickLink-dialog {
    .dialog-title {
        height: 29px !important;
        width: 250px !important;
        color: $ypo-blue-dark-background !important;
        font-family: Raleway, serif !important;
        font-size: 24px !important;
        letter-spacing: 0.17px !important;
        line-height: 29px !important;
    }
}

.quick-link-items {
    border-right: 1px solid $ypo-medium-gray;
    margin-top: 20px;

    &__row {
        padding: 0 20px;
        cursor: pointer !important;
        margin-bottom: 30px;
        transition: 0.3s;
        position: relative;
        color: $ypo-cta;
        font-size: 14px;
        line-height: 20px;

        &:hover {
            color: $ypo_blue;
        }

        &.selectedLink {
            color: $ypo_blue;
            font-weight: 600;

            &::before {
                content: '';
                width: 2px;
                height: 30px;
                background: $ypo_blue;
                position: absolute;
                right: -1px;
            }
        }
    }
}
</style>
